<button [disabled]="loading" (click)="onClickEvent($event)" [ngClass]="style">
  <i
    *ngIf="iconPosition === 'left' && loading === true"
    class="pi pi-spin pi-spinner"
    style="font-size: 1rem"
  ></i>

  <i *ngIf="iconPosition === 'left' && loading === false" [ngClass]="icon"></i>
  {{ text }}
  <i *ngIf="iconPosition === 'right' && loading === false" [ngClass]="icon"></i>

  <i
    *ngIf="iconPosition === 'right' && loading === true"
    class="pi pi-spin pi-spinner"
    style="font-size: 1rem"
  ></i>
</button>
